import { handleActions } from 'redux-actions';
import {
    fetchStoreProductsRequest,
    fetchStoreProductsSuccess,
    fetchStoreProductsError,
    registerStoreProductRequest,
    registerStoreProductSuccess,
    registerStoreProductError,
    executeAppStoreStepRequest,
    executeAppStoreStepSuccess,
    executeAppStoreStepError,
    lookupAppStoreIAPRequest,
    lookupAppStoreIAPSuccess,
    lookupAppStoreIAPError,
} from '../actions/courseStoreProductActions';

const defaultState = {
    records: [],
    isFetching: false,
    isRegistering: null,      // null | 'GOOGLE_PLAY' — store being registered
    isExecutingStep: null,    // null | string — step name being executed
    isLookingUp: false,
    error: null,
};

function mergeStep(records, courseId, updatedStep) {
    return records.map((product) => {
        if (product.store !== 'APP_STORE' || product.course_id !== courseId) return product;
        const steps = product.app_store_steps || [];
        const exists = steps.some((s) => s.step === updatedStep.step);
        const newSteps = exists
            ? steps.map((s) => (s.step === updatedStep.step ? updatedStep : s))
            : [...steps, updatedStep];
        return { ...product, app_store_steps: newSteps };
    });
}

export default handleActions(
    {
        [fetchStoreProductsRequest](state) {
            return { ...state, isFetching: true, error: null };
        },
        [fetchStoreProductsSuccess](state, { payload }) {
            return { ...state, isFetching: false, records: payload };
        },
        [fetchStoreProductsError](state, { payload }) {
            return { ...state, isFetching: false, error: payload };
        },
        [registerStoreProductRequest](state, { payload }) {
            return { ...state, isRegistering: payload };
        },
        [registerStoreProductSuccess](state, { payload }) {
            const updated = state.records.filter(
                (r) => !(r.course_id === payload.course_id && r.store === payload.store)
            );
            return { ...state, isRegistering: null, records: [...updated, payload] };
        },
        [registerStoreProductError](state) {
            return { ...state, isRegistering: null };
        },
        [executeAppStoreStepRequest](state, { payload }) {
            return { ...state, isExecutingStep: payload.step };
        },
        [executeAppStoreStepSuccess](state, { payload }) {
            const { courseId, step } = payload;
            return {
                ...state,
                isExecutingStep: null,
                records: mergeStep(state.records, courseId, step),
            };
        },
        [executeAppStoreStepError](state) {
            return { ...state, isExecutingStep: null };
        },
        [lookupAppStoreIAPRequest](state) {
            return { ...state, isLookingUp: true };
        },
        [lookupAppStoreIAPSuccess](state) {
            return { ...state, isLookingUp: false };
        },
        [lookupAppStoreIAPError](state) {
            return { ...state, isLookingUp: false };
        },
    },
    defaultState,
);
